module.exports = __webpack_public_path__ + "img/logo.cf11cd96.png";